export default {
  pt: {
    'shipments.shipmentsPage.cancelled': 'Carga cancelada.',
    'shipments.shipmentsPage.progressUpdated': 'Andamento atualizado.',
    'shipments.shipmentsPage.allStatuses': 'Todos os status',
    'shipments.shipmentsPage.number': 'Número',
    'shipments.shipmentsPage.contract': 'Contrato',
    'shipments.shipmentsPage.driver': 'Motorista',
    'shipments.shipmentsPage.plate': 'Placa',
    'shipments.shipmentsPage.invoice': 'NF',
    'shipments.shipmentsPage.date': 'Data',
    'shipments.shipmentsPage.title': 'Cargas',
    'shipments.shipmentsPage.eyebrow': 'Operação',
    'shipments.shipmentsPage.subtitle': 'Andamento das cargas (6 estados), campos fiscais e lista de descarga única.',
    'shipments.shipmentsPage.list': 'Lista',
    'shipments.shipmentsPage.searchStatus': 'Buscar status…',
    'shipments.shipmentsPage.loadFailed': 'Não foi possível carregar.',
    'shipments.shipmentsPage.empty': 'Nenhuma carga encontrada.',
    'shipments.shipmentsPage.kanban': 'Kanban',
    'shipments.shipmentsPage.status.draft': 'Rascunho',
    'shipments.shipmentsPage.status.awaiting_harvest': 'Aguardando colheita',
    'shipments.shipmentsPage.status.loading': 'Carregando',
    'shipments.shipmentsPage.status.awaiting_invoice': 'Aguardando nota fiscal',
    'shipments.shipmentsPage.status.awaiting_unload': 'Aguardando descarga',
    'shipments.shipmentsPage.status.unloading': 'Em descarga',
    'shipments.shipmentsPage.status.released': 'Liberada',
    'shipments.shipmentsPage.status.cancelled': 'Cancelada',
  },
  en: {
    'shipments.shipmentsPage.cancelled': 'Load cancelled.',
    'shipments.shipmentsPage.progressUpdated': 'Progress updated.',
    'shipments.shipmentsPage.allStatuses': 'All statuses',
    'shipments.shipmentsPage.number': 'Number',
    'shipments.shipmentsPage.contract': 'Contract',
    'shipments.shipmentsPage.driver': 'Driver',
    'shipments.shipmentsPage.plate': 'License plate',
    'shipments.shipmentsPage.invoice': 'Invoice',
    'shipments.shipmentsPage.date': 'Date',
    'shipments.shipmentsPage.title': 'Loads',
    'shipments.shipmentsPage.eyebrow': 'Operations',
    'shipments.shipmentsPage.subtitle': 'Load progress (6 statuses), tax fields and a single unloading list.',
    'shipments.shipmentsPage.list': 'List',
    'shipments.shipmentsPage.searchStatus': 'Search status…',
    'shipments.shipmentsPage.loadFailed': 'Could not load.',
    'shipments.shipmentsPage.empty': 'No loads found.',
    'shipments.shipmentsPage.kanban': 'Kanban',
    'shipments.shipmentsPage.status.draft': 'Draft',
    'shipments.shipmentsPage.status.awaiting_harvest': 'Awaiting harvest',
    'shipments.shipmentsPage.status.loading': 'Loading',
    'shipments.shipmentsPage.status.awaiting_invoice': 'Awaiting invoice',
    'shipments.shipmentsPage.status.awaiting_unload': 'Awaiting unloading',
    'shipments.shipmentsPage.status.unloading': 'Unloading',
    'shipments.shipmentsPage.status.released': 'Released',
    'shipments.shipmentsPage.status.cancelled': 'Cancelled',
  },
  es: {
    'shipments.shipmentsPage.cancelled': 'Carga cancelada.',
    'shipments.shipmentsPage.progressUpdated': 'Progreso actualizado.',
    'shipments.shipmentsPage.allStatuses': 'Todos los estados',
    'shipments.shipmentsPage.number': 'Número',
    'shipments.shipmentsPage.contract': 'Contrato',
    'shipments.shipmentsPage.driver': 'Conductor',
    'shipments.shipmentsPage.plate': 'Placa',
    'shipments.shipmentsPage.invoice': 'Factura',
    'shipments.shipmentsPage.date': 'Fecha',
    'shipments.shipmentsPage.title': 'Cargas',
    'shipments.shipmentsPage.eyebrow': 'Operación',
    'shipments.shipmentsPage.subtitle': 'Progreso de las cargas (6 estados), campos fiscales y lista única de descarga.',
    'shipments.shipmentsPage.list': 'Lista',
    'shipments.shipmentsPage.searchStatus': 'Buscar estado…',
    'shipments.shipmentsPage.loadFailed': 'No se pudo cargar.',
    'shipments.shipmentsPage.empty': 'No se encontraron cargas.',
    'shipments.shipmentsPage.kanban': 'Kanban',
    'shipments.shipmentsPage.status.draft': 'Borrador',
    'shipments.shipmentsPage.status.awaiting_harvest': 'Esperando cosecha',
    'shipments.shipmentsPage.status.loading': 'Cargando',
    'shipments.shipmentsPage.status.awaiting_invoice': 'Esperando factura',
    'shipments.shipmentsPage.status.awaiting_unload': 'Esperando descarga',
    'shipments.shipmentsPage.status.unloading': 'En descarga',
    'shipments.shipmentsPage.status.released': 'Liberada',
    'shipments.shipmentsPage.status.cancelled': 'Cancelada',
  },
}
